// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeasingCheckPaymentsWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingCheckPaymentsWebApiHandler_checkActivePayments,
  LeasingCheckPaymentsWebApiHandler_checkActivePayments_Path,
} from '@zg-rentals/ts-leasing-client';

import type { LeasingCheckActivePaymentsResponseDto } from '@zg-rentals/ts-leasing-client';

interface CheckActivePaymentsParams {
  leaseId: number;
}

export type LeasingCheckPaymentsWebApiHandler_checkActivePayments_Options = UseQueryOptions<
  LeasingCheckActivePaymentsResponseDto,
  unknown,
  LeasingCheckActivePaymentsResponseDto,
  Array<string | CheckActivePaymentsParams>
>;

const LeasingCheckPaymentsWebApiHandler_checkActivePayments_GetKey = (getParams: CheckActivePaymentsParams) => [
  LeasingCheckPaymentsWebApiHandler_checkActivePayments_Path,
  getParams,
];

/**
 * check if payments are active for a lease
 */
export const useLeasingCheckPaymentsWebApiHandler_checkActivePayments = (
  getParams: CheckActivePaymentsParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingCheckPaymentsWebApiHandler_checkActivePayments_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingCheckPaymentsWebApiHandler_checkActivePayments_GetKey(getParams),
    queryFn: () => LeasingCheckPaymentsWebApiHandler_checkActivePayments(getParams, httpClient),
  });
};
useLeasingCheckPaymentsWebApiHandler_checkActivePayments.getKey =
  LeasingCheckPaymentsWebApiHandler_checkActivePayments_GetKey;
